import React, { useEffect, useState } from "react";
import {
  Route, Switch, BrowserRouter, Redirect, useHistory,
} from "react-router-dom";
import Sidebar from "./Layout/Sidebar";
import PageNotFound from "./PageNotFound";
import { axiosRequestInterceptor, axiosResponseInterceptor } from "../utils/interceptor";
import { getAuthorizedRoutes } from "../utils/authorizedRoutes";
import { gerUserDetail } from "../actions/signIn";
import { getUser, createUserPermissionMap } from "../utils/helpers";

import "./LoggedIn.css";

axiosRequestInterceptor();
axiosResponseInterceptor();
const RouterContent = ({ loading }) => {
  const history = useHistory();
  const [routesToShow, setRoutesToShow] = useState(null);
  const [defaultPath, setDefaultPath] = useState("");
  useEffect(() => {
    // Set up the authorized routes and default path after fetching the user permissions
    if (loading === false) {
      const routes = getAuthorizedRoutes();
      setRoutesToShow(routes.map((route, index) => <Route key={index} path={route.path} exact component={route.component} />));
      const path = typeof routes[0].path === "object" ? routes[0].path[0] : routes[0].path;
      setDefaultPath(path);
    }
  }, [loading]);

  return (
    <>
      {loading && (<div />)}
      {!loading && (
      <div className="LoggedIn__Container__Content">
        <Sidebar history={history} />
        <div className="LoggedIn__Container__Content__Switch">
          <Switch>
            <Route path="/" exact render={() => <Redirect to={defaultPath} />} />
            <Route path="/login" exact render={() => <Redirect to={defaultPath} />} />
            {routesToShow}
            <Route component={PageNotFound} />
          </Switch>
        </div>
      </div>
      )}
    </>
  );
};

class LoggedIn extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  async componentDidMount() {
    const user = getUser();

    if (!user) {
      this.setState({ loading: false });
      return;
    }
    const userDetail = await gerUserDetail();
    if (userDetail.success) {
      const permissionMap = createUserPermissionMap(userDetail);
      sessionStorage.setItem(
        "user_details_automation",
        JSON.stringify({ ...user, role: userDetail.role, permissionMap }),
      );
    }
    this.setState({ loading: false });
  }

  render() {
    const { loading } = this.state;
    return (
      <div className="LoggedIn__Container">
        <BrowserRouter>
          <RouterContent loading={loading} />
        </BrowserRouter>
      </div>
    );
  }
}

export default LoggedIn;
